export default date => {
  let fecha = new Date()
  let fechaTo = new Date()

  let from = fecha.setDate(fecha.getDate() - 7)
  let newDate = new Date(from)
  let dayFrom = newDate.getDate()
  let monthFrom = newDate.getMonth() + 1
  let yearFrom = newDate.getFullYear()

  switch (date) {
    case 'dateFrom':
      return `${yearFrom}/${monthFrom}/${dayFrom}`
      break
    case 'dateTo':
      return `${fechaTo.getFullYear()}/${fechaTo.getMonth() +
        1}/${fechaTo.getDate()}`
      break
    default:
      return `${yearFrom}/${monthFrom}/${dayFrom}`
      break
  }
}



// WEBPACK FOOTER //
// ./src/util/ConfigDates.js